
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Footer from './footer.vue'
import { enterFullScreen } from '@xt/client/helpers/system'
import { Bind, Debounce } from 'lodash-decorators'

@Observer
@Component({
  components: { Footer }
})
export default class PlaybackPageView extends Vue {
  @Prop({ default: false }) toggle: boolean
  @Prop({ default: false }) fullscreen: boolean

  controlVisible = true
  controlDuration = 4000
  controlTimer: ReturnType<typeof setTimeout> | null = null

  @Watch('toggle')
  logToggle(val) {
    console.log('logToggle', val)
  }

  get PageStore() {
    return this.$store.$genseePlayback
  }

  @Debounce(600, { leading: true, trailing: false })
  @Bind()
  handleDocDblClick() {
    this.$emit('toggle-fullscreen', 'doc')
  }

  docBoxMoveHandler() {
    if (!this.PageStore.videoState.isFullScreen) return
    this.recoverControlTimer()
  }

  resetControlTimer() {
    this.controlVisible = false
    if (this.controlTimer) {
      clearTimeout(this.controlTimer)
      this.controlTimer = null
    }
  }

  recoverControlTimer() {
    this.controlVisible = true
    if (this.controlTimer) {
      clearTimeout(this.controlTimer)
      this.controlTimer = null
    }
    this.controlTimer = setTimeout(this.resetControlTimer, this.controlDuration)
  }

  fullscreenHandler() {
    const targetNode = document.querySelector('#doc-widget-box') as HTMLDivElement
    enterFullScreen(targetNode)
    this.PageStore.setCurrentFullScreenNode('doc')
  }

  @Watch('fullscreen')
  changeFullscreen(value: boolean) {
    if (value) {
      this.recoverControlTimer()
    }
  }

  created() {}
  mounted() {}
  destroyed() {}
}
